import { TableListColumnFilter } from "./TableListColumnFilter.js";
import { naturalSort } from "@synthesis/shared-utils";
//#region src/TableListColumnFilter/TableListColumnFilter.lib.tsx
const EMPTY_VALUE_KEY = "__table_list_filter_empty__";
const getTableColumnListFilter = (params = {}) => ({
	filter: TableListColumnFilter,
	filterParams: {
		...params,
		filtersLineValueFormatter: params.filtersLineValueFormatter ?? (({ items, selectedItemsMap }) => {
			return items.filter((item) => {
				const id = params.getItemId?.(item) ?? item.id;
				return Boolean(id && selectedItemsMap[id]);
			}).map((item) => (params.getItemLabel ? params.getItemLabel(item) : item.label) ?? "");
		}),
		...params.otherFilterParams
	}
});
const isListTableFilter = (item) => Boolean(typeof item === "object" && item && "items" in item && Array.isArray(item.items));
const provisionalItem = (raw) => ({ value: raw });
const getFilterKeyForValue = (raw, getItemId) => {
	const item = provisionalItem(raw);
	if (getItemId) return getItemId(item);
	if (raw === null || raw === void 0) return EMPTY_VALUE_KEY;
	return String(raw);
};
const buildLocalItemsFromGrid = (api, colDef, getItemId, getItemLabel, expandCellValueToFilterItems) => {
	const field = colDef.field;
	if (!field) return [];
	const byId = /* @__PURE__ */ new Map();
	const mergeExpandedItems = (items) => {
		for (const item of items) {
			const id = getItemId ? getItemId(item) : item.id;
			if (!id || byId.has(id)) continue;
			const label = getItemLabel?.(item) ?? item.label ?? id;
			byId.set(id, {
				...item,
				id,
				label
			});
		}
	};
	api.forEachNode((node) => {
		if (node.rowPinned || node.group || node.footer) return;
		const data = node.data;
		if (!data) return;
		const raw = data[field];
		if (expandCellValueToFilterItems) {
			mergeExpandedItems(expandCellValueToFilterItems(raw));
			return;
		}
		const id = getFilterKeyForValue(raw, getItemId);
		if (byId.has(id)) return;
		const provisional = provisionalItem(raw);
		const label = getItemLabel?.(provisional) ?? (raw === null || raw === void 0 ? "" : typeof raw === "object" ? JSON.stringify(raw) : String(raw));
		byId.set(id, {
			...provisional,
			id,
			label
		});
	});
	return Array.from(byId.values()).toSorted((a, b) => naturalSort(String(a.label ?? ""), String(b.label ?? "")));
};
const defaultItemsFilter = (item, searchQuery, getItemLabelProp) => {
	const q = searchQuery.trim().toLowerCase();
	const label = (getItemLabelProp ? getItemLabelProp(item) : item.label) ?? "";
	return String(label).toLowerCase().includes(q);
};
const itemMatchesSearch = (item, searchQuery, itemsFilter, getItemLabelProp) => {
	if (!searchQuery.trim().toLowerCase()) return true;
	if (itemsFilter) return itemsFilter(item, searchQuery);
	return defaultItemsFilter(item, searchQuery, getItemLabelProp);
};
//#endregion
export { EMPTY_VALUE_KEY, buildLocalItemsFromGrid, getFilterKeyForValue, getTableColumnListFilter, isListTableFilter, itemMatchesSearch, provisionalItem };

//# sourceMappingURL=TableListColumnFilter.lib.js.map